// core
import React from "react";
import { ThemeProvider, createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
    spacing: 8,
    typography: {
        fontFamily: "'otallatin', arial, helvetica, sans-serif",
        h1: {
            fontSize: undefined,
            lineHeight: undefined,
            fontWeight: undefined
        }
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                "body": {
                    overflowX: "hidden"
                },
                "*:focus": {
                    outline: "none"
                }
            }
        }
    }
});

const MaterialThemeProvider: React.FC<{}> = (props) => {
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default MaterialThemeProvider;
